import { message } from 'antd'
import { ClientUser } from '../../../api/external/ClientUser'
import Accounts from '../../../components/People/Accounts/Accounts'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalData from '../../../elements/Hooks/useModalData'
import { pick } from 'lodash'
import { strVal } from '../../../modules/Utils'
import React, { useState } from 'react'

import { withRouter } from 'react-router-dom'

function AccountsCont(props) {
  const key = props.match.params.key
  const { list, fetching, fetch } = useFetchList(ClientUser.usersList)
  const user = list.find((u) => strVal(u, 'client.member._key') === key)
  const { list: listClient, fetching: fetchingClient } = useFetchList(ClientUser.listClients)
  const client = listClient.find((u) => strVal(u, 'member._key') === key)
  const { submitting, formRef: userRef, onCancel, checkForm, setSubmitting } = useModalData(
    ClientUser.create,
    ClientUser.update,
    fetch
  )

  async function update() {
    const updatedObject = await checkForm()
    setSubmitting(true)
    try {
      await ClientUser.update({
        ...updatedObject,
        ...pick(user, ['_id', '_key', '_rev']),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await ClientUser.create({
        ...newObject,
        client,
        fullName: strVal(client, 'member.fn'),
        organisation: strVal(client, '_id'),
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <Accounts
      {...{
        user,
        submitting,
        submit,
        update,
        userRef,
        client,
        fetchingClient,
      }}
      loading={fetchingClient && fetching}
    />
  )
}

export default withRouter((AccountsCont))
